import React, { useEffect, useState } from 'react';
import '../styles/AnnouncementPage.css';
import { useLanguage } from '../../contexts/LanguageContext';

const AnnouncementPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const translations = {
    kz: {
      title: "Кітапхананың жұмыс уақыты",
      workingHours: "Кітапхана күнделікті сағат",
      timeRange: "09.00-ден 20.00-ге дейін",
      exceptDays: "дүйсенбі, тазалық және мереке күндерінен басқа",
      openDays: "күндері ашық",
      weekendWork: "Сенбі және жексенбі күндері",
      libraryWorks: "кітапхана жұмыс істейді",
      cleaningDay: "Тазалық күні -",
      lastWorkDay: "әр айдың соңғы жұмасы",
      conducted: "өткізіледі"
    },
    ru: {
      title: "Режим работы библиотеки",
      workingHours: "Библиотека работает ежедневно с",
      timeRange: "09.00 до 20.00",
      exceptDays: "кроме понедельника, санитарного дня и праздничных дней",
      openDays: "",
      weekendWork: "В субботу и воскресенье",
      libraryWorks: "библиотека работает",
      cleaningDay: "Санитарный день -",
      lastWorkDay: "последняя пятница каждого месяца",
      conducted: ""
    },
    en: {
      title: "Library opening hours",
      workingHours: "The library is open daily from",
      timeRange: "09:00 to 20:00",
      exceptDays: "except Mondays, cleaning days, and holidays",
      openDays: "",
      weekendWork: "On Saturdays and Sundays",
      libraryWorks: "the library is open",
      cleaningDay: "Cleaning day -",
      lastWorkDay: "the last Friday of every month",
      conducted: ""
    }
  };

  const t = translations[currentLanguage] || translations.kz;

  return (
    <div className="page-container">
      <div className="floating-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>
      <div className="content-wrapper">
        <h2 className="title">
          {t.title}
        </h2>
        <div className={`announcement-text ${isVisible ? 'visible' : ''}`}>
          <div className="section">
            <span className="text-line">
              {t.workingHours} <span className="highlight">{t.timeRange}</span>
            </span>
            <span className="text-line">
              <span className="highlight-special">{t.exceptDays}</span> {t.openDays}
            </span>
            <span className="text-line">
              <span className="highlight">{t.weekendWork}</span> {t.libraryWorks}
            </span>
            <span className="text-line">
              {t.cleaningDay} <span className="highlight-special">{t.lastWorkDay}</span> {t.conducted}
            </span>
          </div>

        </div>
        <div className="decorative-line"></div>
      </div>
      <div className="background-glow"></div>
    </div>
  );
};

export default AnnouncementPage;
